import React from "react";
import ProductList from "../Components/ProductList";

const services = [
  { name: "Salons", path: "/salons", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
  { name: "Outside Spa", path: "/outside-spa", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
  { name: "Tourist", path: "/tourist", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
  { name: "Body Guard", path: "/body-guard", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
];

function Services() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Services</h1>
      <ProductList products={services} isCategory />
    </div>
  );
}

export default Services;